export type VideoKind = 'mp4'|'webm'|'ogg'|'m4v'|'unknown';
const extToCT: Record<string,string> = { mp4:'video/mp4', webm:'video/webm', ogg:'video/ogg', ogv:'video/ogg', m4v:'video/x-m4v' };
const ctToKind = (ct:string): VideoKind => { const s = ct.toLowerCase(); if (s.includes('webm')) return 'webm'; if (s.includes('ogg')) return 'ogg'; if (s.includes('m4v')) return 'm4v'; if (s.includes('mp4')) return 'mp4'; return 'unknown'; };
const nameToExt = (name?:string) => (name||'').toLowerCase().split('.').pop() || '';
export function detectVideo(file?: File|null, fallbackName?: string): { contentType: string|null; kind: VideoKind; reason?: string } {
  const rawType = file?.type || '';
  // 1) If browser gave a video/* type, use it
  if (/^video\//i.test(rawType)) return { contentType: rawType, kind: ctToKind(rawType) };
  // 2) Many browsers report '' or application/octet-stream. Use filename extension instead
  const ext = nameToExt(file?.name || fallbackName);
  const mapped = extToCT[ext];
  if (mapped) return { contentType: mapped, kind: ctToKind(mapped) };
  // 3) Still unknown → unsupported
  return { contentType: null, kind: 'unknown', reason: `Unsupported extension '${ext || 'none'}' and type '${rawType || 'empty'}'` };
}
export const ACCEPT_ATTR = 'video/mp4,video/webm,video/ogg,video/x-m4v,.mp4,.webm,.ogg,.ogv,.m4v';
